import axios from "axios";

const BASE_URL = process.env.REACT_APP_API_URL;

var configHeader = {};

export const axiosFetch = async (configObj) => {
 
  var userDetails = localStorage.getItem('argus_user') !== null ? localStorage.getItem('argus_user') : null;
 
  var token =  userDetails !== null && JSON.parse(userDetails).token !== null ? JSON.parse(userDetails).token : "";
  if (token) {
   
      configHeader = {
       
        'Accept': 'application/json, text/plain, */*',
        'Content-Type': 'application/json',
        "Authorization" : `Bearer ${token}`,
        
      }
     
    }
  else {
    configHeader = {
       'Accept': "application/json, text/plain",
       'Content-Type': 'application/json'
    }
  }
   const ConfigAxios =  axios.create({
    baseURL: BASE_URL,
    headers: configHeader,
   });
  
  const { method, url, requestConfig = {} } = configObj;
  try {
    const res = await ConfigAxios[method.toLowerCase()](url, {
      ...requestConfig,
    });
    return res;
  } catch (err) {
    return err.response;
  }
};
